/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_ImportInputs */



/**
* | output |
* | --- |
* | "Translation Import..." |
*
* @param {Translation_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import = /** @type {((inputs?: Translation_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation de traduction...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzung importieren...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione traduzione...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт перевода...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de traducción...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译导入...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳のインポート...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद आयात...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de traduções...")
	return /** @type {LocalizedString} */ ("Translation Import...")
});